var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"fraud-evidence"},[_vm._l((_vm.segments),function(seg,i){return [(seg && typeof seg === 'object')?_c('link-tag-view',{key:'t' + i,attrs:{"label":seg.label,"href":seg.href || null,"click":seg.click || null}}):_c('span',{key:'s' + i},[_vm._v(_vm._s(seg))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }